export default __webpack_public_path__ + "static/media/Jenny_Timur-181_websize_tn.efe8ae09.jpg";